import type { FeatureContext } from './featureContext';
import { initMusic } from '../music';

/** Injectable seams for unit tests; defaults are the real modules. */
export interface MusicInstallDeps {
  initMusic?: typeof initMusic;
}

/**
 * Background music (ADR-0146): the settings-panel music controls - a wholly
 * independent channel from the SFX controls (its own slider/mute and its own
 * localStorage keys, routed to the MusicPlayer's dedicated gain node; the persisted
 * choice is applied up front, which MusicPlayer handles even before init resolves) -
 * and the login playlist start on every Welcome. Entering the world is a user
 * gesture, so the shared AudioContext is already resumed and the first track can
 * actually sound. `start()` is idempotent: a reconnect's fresh Welcome is a no-op,
 * so the music plays on uninterrupted rather than restarting or stacking a second
 * player. The duel/storm/arena overrides are driven by their own installers
 * through `ctx.music.setCombat/setStorm/setArena`.
 */
export function installMusic(ctx: FeatureContext, deps: MusicInstallDeps = {}): void {
  (deps.initMusic ?? initMusic)({
    onMuteChange: (muted) => ctx.music.setMuted(muted),
    onVolumeChange: (level) => ctx.music.setVolume(level),
  });
  ctx.events.on('welcome', () => ctx.music.start());
}
